import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
export function MechanismSection() {
  const steps = [{
    title: 'Comida suficiente',
    desc: 'Para que la noche no sea una factura de todo el día.',
    number: '01'
  }, {
    title: 'Fricción ambiental',
    desc: 'Para que el piloto automático choque contra algo.',
    number: '02'
  }, {
    title: 'Guión de urgencia (90s)',
    desc: 'Para atravesar el pico sin negociar contigo.',
    number: '03'
  }, {
    title: 'Post-atracón sin castigo',
    desc: 'Para cortar el ciclo culpa → restricción → atracón.',
    number: '04'
  }];
  return <section className="py-24 px-6 md:px-12 bg-[#0a0e1a] text-[#f5f5f0] relative overflow-hidden" data-id="element-87">
      {/* Decorative glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-amber-900/10 rounded-full blur-[100px] pointer-events-none" data-id="element-88" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-89">
        <div className="text-center mb-16" data-id="element-90">
          <h2 className="text-4xl md:text-5xl font-bold text-amber-500 mb-4 tracking-tight" data-id="element-91">
            NOCHE-CERRADA
          </h2>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-92">
            Un protocolo de 14 días para cortar atracones nocturnos con 4
            palancas en orden.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16" data-id="element-93">
          {steps.map((step, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-[#111827] p-8 rounded-2xl border border-gray-800 relative group hover:border-amber-500/30 transition-all" data-id="element-94">
              <div className="absolute top-6 right-6 text-4xl font-bold text-gray-800 group-hover:text-amber-900/40 transition-colors" data-id="element-95">
                {step.number}
              </div>
              <h3 className="text-2xl font-bold text-white mb-3 relative z-10" data-id="element-96">
                {step.title}
              </h3>
              <p className="text-gray-400 text-lg leading-relaxed relative z-10" data-id="element-97">
                {step.desc}
              </p>
            </motion.div>)}
        </div>

        <div className="text-center mb-20" data-id="element-98">
          <p className="text-2xl font-serif italic text-amber-100/80" data-id="element-99">
            "No te pido perfección. Te pido implementación."
          </p>
        </div>

        {/* Relapse Section */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="bg-[#1a1f2e] rounded-3xl p-8 md:p-12 border border-gray-800 max-w-3xl mx-auto text-center" data-id="element-100">
          <h3 className="text-2xl font-bold text-white mb-6" data-id="element-101">¿Y si recaigo?</h3>
          <p className="text-gray-300 text-lg mb-6 leading-relaxed" data-id="element-102">
            Si recaes, aquí no hay drama… pero tampoco hay teatro. Hay un
            protocolo post-atracón diseñado para no castigar, no compensar y no
            reactivar el ciclo.
          </p>
          <p className="text-amber-400 font-bold text-xl mb-8" data-id="element-103">
            La recaída no se convierte en identidad. Se convierte en dato.
          </p>

          <div className="flex justify-center" data-id="element-104">
            <CtaButton text="Acceder al protocolo" data-id="element-105" />
          </div>
        </motion.div>
      </div>
    </section>;
}